export const ServiceTypeStatusOptionKey = 'service-type-status-option';
export const ServiceTypeKey = 'service-type';
export const ServiceTypeCodeKey = 'service-type-code';
export const ServiceTypeTargetOptionKey = 'service-type-target-option';
export const ServiceTypeAvailableStatusesKey = 'service-type-available-statuses';